import { Program } from '@shared/constants';

type Unit = {
  unitId: string | number;
  denId: string;
  denType: string;
  denNumber: string;
  patrolId: string;
  patrolName: string;
  program?: Program;
  unitFullName: string;
  organizationName?: string;
  isParentGuardian?: boolean;
  acceptGender?: string;
  organizationGuid?: string;
};

export default (
  unit: Unit,
  userUnits: Unit[] = [],
  isDenchiefPack: boolean = false,
  DCPackOrgGuid?: string,
) => {
  const foundUnit = userUnits.find(item => +item.unitId === +unit.unitId);
  let program =
    unit.denId || unit.patrolId || !foundUnit ? undefined : foundUnit.program;

  let organizationName = unit.unitFullName;
  let isParentGuardian, acceptGender, organizationGuid;

  if (unit.denId || unit.patrolId) {
    organizationName = `${
      unit.denId ? `${unit.denType} ${unit.denNumber}` : ''
    }${unit.patrolId ? `${unit.patrolName}` : ''}`;
  } else if (foundUnit) {
    organizationName = foundUnit.organizationName as string;
    isParentGuardian = foundUnit.isParentGuardian;
    acceptGender = foundUnit.acceptGender;
    organizationGuid = foundUnit.organizationGuid;
  }

  // Den chiefs packs most likely not be in the organizations known by logged in user
  if (isDenchiefPack && !program && !(unit.denId || unit.patrolId)) {
    program = Program.CUB_SCOUT;
    const [programName, number] = unit.unitFullName.split(' ');
    organizationName = `${programName} ${number}`;
  }

  if (
    isDenchiefPack &&
    !organizationGuid &&
    DCPackOrgGuid &&
    !(unit.denId || unit.patrolId)
  ) {
    organizationGuid = DCPackOrgGuid;
  }

  return {
    program,
    organizationName,
    isParentGuardian,
    acceptGender,
    organizationGuid,
  };
};
